<template>
    <p class="text-center text-base md:text-lg text-gray-400 py-4  rounded leading-wide mb-5 border border-dashed border-gray-100">
        <slot />
    </p>
</template>
